export default "__VITE_ASSET__SPzih4Ue__"